import React from 'react';

import { useSelector } from 'react-redux';

import { PortalModalDialogSliceState } from 'store/store.types';

import DialogModal from '../DialogModal/DialogModal';

import { modalConfigs } from './constants/modalConfigs';

const DialogModalManager = () => {
  const currentModal = useSelector(
    ({
      portalModalDialogs
    }: {
      portalModalDialogs: PortalModalDialogSliceState;
    }) => portalModalDialogs.currentModal
  );
  const modalActions = useSelector(
    ({
      portalModalDialogs
    }: {
      portalModalDialogs: PortalModalDialogSliceState;
    }) => portalModalDialogs.modalActions
  );

  if (!currentModal || !modalActions) return null;

  return (
    <DialogModal
      isOpen={!!currentModal}
      title={modalConfigs[currentModal]?.title}
      description={modalConfigs[currentModal]?.description}
      modalActions={modalActions}
    />
  );
};

export default DialogModalManager;
